module.exports = __webpack_public_path__ + "assets/img/hero.c91b0f47.jpg";